import { push } from 'connected-react-router';

class NavigateActions {
  static navigate(route) {
    return function (dispatch) {
      dispatch(push(route));
    };
  }
}

export default NavigateActions;
